<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">

  <div class="esf-main-sidebar__content">
    <h4 i18n='Title@@customerOverviewComponent.modalTitle.submissionDetails' class="esf-heading--sub-section" style="margin-bottom: 0.2em;">Submission details</h4>

    <p class="esf-ticket__info-text" style="margin-bottom: 0.2em;">
      <span i18n='Text@@invoiceComponent.text.created'>Created</span>
      <span>: {{ selectedSubmission.submittedAt.date | date:selectedSubmission.submittedAt.format }}</span>
    </p>

    <div class="esf-accordion esf-accordion--info-tiles" style="padding-top: 20px;">
      <ng-container *ngIf="selectedSubmission?.primaryTicketRequest">
        <div class="esf-accordion__unit address">
          <div class="esf-accordion__trigger" [ngClass]="{'-is-open': primaryRequestOpened}" (click)="toggleSection('primaryRequest')">
            <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
              <span class="esf-action-heading__text" i18n='@@submissionDetailsComponent.heading.primaryRequest'>Primary Request</span>
            </h4>
          </div>
          <div class="esf-accordion__target" [ngClass]="{'no-display': !primaryRequestOpened}">

            <div class="esf-info-tile esf-info-tile--static esf-info-tile--event">
              <div class="esf-info-tile__content">
                <table class="esf-table"
                       app-table
                       [smallTable]="true"
                       [columns]="columns"
                       [keys]="keys"
                       [data]="selectedSubmission.primaryTicketRequest.tickets">
                </table>
              </div>
            </div>

          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedSubmission?.secondaryTicketRequest">
        <div class="esf-accordion__unit address">
          <div class="esf-accordion__trigger" [ngClass]="{'-is-open': secondaryRequestOpened}" (click)="toggleSection('secondaryRequest')">
            <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
              <span class="esf-action-heading__text" i18n='@@submissionDetailsComponent.heading.secondaryRequest'>Secondary Request</span>
            </h4>
          </div>
          <div class="esf-accordion__target" [ngClass]="{'no-display': !secondaryRequestOpened}">

            <div class="esf-info-tile esf-info-tile--static esf-info-tile--event">
              <div class="esf-info-tile__content">
                <table class="esf-table"
                       app-table
                       [smallTable]="true"
                       [columns]="columns"
                       [keys]="keys"
                       [data]="selectedSubmission.secondaryTicketRequest.tickets">
                </table>
              </div>
            </div>

          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="true">
        <div class="esf-accordion__unit address">
          <div class="esf-accordion__trigger" [ngClass]="{'-is-open': additionalOptionsOpened}" (click)="toggleSection('additionalOptions')">
            <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
              <span class="esf-action-heading__text" i18n='@@submissionDetailsComponent.heading.additionalOptions'>Additional Options</span>
            </h4>
          </div>
          <div class="esf-accordion__target" [ngClass]="{'no-display': !additionalOptionsOpened}">

            <div class="esf-info-tile esf-info-tile--static esf-info-tile--event">
              <div class="esf-info-tile__content">
                <div class="esf-ticket">
                  <div class="esf-ticket__info">
                    <span class="esf-ticket__info-item esf-ticket__stand">
                      <span class="esf-ticket__info-label" i18n='Text@@submissionDetailsComponent.text.priceDeviation'>Price deviation</span>
                      <span class="esf-ticket__info-text">
                        {{ selectedSubmission.translatedDeviation }}
                      </span>
                    </span>
                    <span class="esf-ticket__info-item esf-ticket__block"></span>
                    <span class="esf-ticket__info-item esf-ticket__stand">
                      <span class="esf-ticket__info-label" i18n='Text@@submissionDetailsComponent.text.nonContiguousSeating'>Non contiugous seating</span>
                      <span class="esf-ticket__info-text">
                        {{ selectedSubmission.translatedContiguousSeating }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </ng-container>
    </div>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons *ngIf="true"
                          [isFieldValid]="false"
                          [form]="'updateCommunicationForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [showSubmit]="false"
                          (cancelButton)="customerService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition -is-open"
     (click)="customerService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
